import { stateSetters, stateGetters } from '@/store/store-utils'

const defaultState = {
  fast: false,
  history: [],
}

export default {
  name: 'games/dice',
  namespaced: true,
  state: () => defaultState,
  getters: {
    ...stateGetters(defaultState),
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    async bet({ commit, getters }, form) {
      const resp = await this.$api.games.dice.bet(form)
      commit('user/addOrRemoveBalance', -form.amount, { root: true })

      return resp
    },
  },
}
